// import React from "react";
// import "../Styles/AboutUs.css"

// const AboutUs = () => {
//   return (
//     <div className="about">
//       <h1>About Us</h1>
//       <p>
//       Pravartan is a community initiative that started in 2016 with a simple dream – to bring people together and create positive change.
// Based in Raigad district, Maharashtra, we’ve been working on different social, educational, and environmental activities ever since.
// Our main focus is to encourage leadership and build self-reliance among people so that they can shape their own future.

// Over the years, we’ve organised stationery donation drives to support students with their education.
// We’ve stood with families during tough times by providing relief for flood-affected areas.
// We’ve held awareness sessions on menstrual hygiene and health, breaking barriers and encouraging open conversations.
// We’ve planted trees and worked on environmental projects to care for our planet.
// We’ve also organised events and workshops that help uplift women socially and economically.

// At Pravartan, we believe small steps create big changes.
// Every activity we do is guided by the belief that when communities come together, they can create a stronger and more hopeful tomorrow.
// We are proud of the journey so far, and excited to continue inspiring people to lead, participate, and make a difference.

//       </p>
//       <div className="social-links">
//         <a
//           href="https://facebook.com/groups/669605727093868/"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           <FaFacebook className="social-icon facebook" />
//         </a>
//         <a
//           href="https://www.instagram.com/pravartan_?igsh=Zm1hZjFkb2t1bHRn"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           <FaInstagram className="social-icon instagram" />
//         </a>
//         <a
//           href="https://youtube.com/@pravartanpodcast?si=6Hr2lIBqi4sweEoj"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           <FaYoutube className="social-icon youtube" />
//         </a>
//       </div>
//     </div>
//   );
// };

// export default AboutUs;

import React from "react";
import "../Styles/AboutUs.css";
import aboutImg from "../assets/gallery12.jpeg"; // replace with your image
import { FaFacebook, FaInstagram, FaYoutube } from "react-icons/fa";

const AboutUs = () => {
  return (
    <>
      <section className="about">
        <div className="about-image">
          <img src={aboutImg} alt="About Us" />
        </div>
        <div className="about-text">
          <h2>About Us</h2>
          <p>
            Pravartan is a community initiative that started in 2016 with a
            simple dream – to bring people together and create positive change.
            Based in Raigad district, Maharashtra, we’ve been working on
            different social, educational, and environmental activities ever
            since. Our main focus is to encourage leadership and build
            self-reliance among people so that they can shape their own future.
            Over the years, we’ve organised stationery donation drives to
            support students with their education. We’ve stood with families
            during tough times by providing relief for flood-affected areas.
            We’ve held awareness sessions on menstrual hygiene and health,
            breaking barriers and encouraging open conversations. We’ve planted
            trees and worked on environmental projects to care for our planet.
            We’ve also organised events and workshops that help uplift women
            socially and economically. At Pravartan, we believe small steps
            create big changes. Every activity we do is guided by the belief
            that when communities come together, they can create a stronger and
            more hopeful tomorrow. We are proud of the journey so far, and
            excited to continue inspiring people to lead, participate, and make
            a difference.
          </p>
        </div>
      </section>
      <center>
        {" "}
        <h2>Follow Us</h2>
      </center>

      <div className="social-links">
        <a
          href="https://facebook.com/groups/669605727093868/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaFacebook className="social-icon facebook" />
        </a>
        <a
          href="https://www.instagram.com/pravartan_?igsh=Zm1hZjFkb2t1bHRn"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaInstagram className="social-icon instagram" />
        </a>
        <a
          href="https://youtube.com/@pravartanpodcast?si=6Hr2lIBqi4sweEoj"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaYoutube className="social-icon youtube" />
        </a>
      </div>
    </>
  );
};

export default AboutUs;
